/*jshint esversion: 6 */
import { find, map, sortBy } from 'lodash-es';

export let wisService = function (locale, numericCountryCode) {
    const url = import.meta.env.VITE_APP_WIS_API_URL

    const regionItem = (item) => {
        return {
            id: item.id,
            name: item.translations[locale]
        }
    }

    const that = {}
    that._getRegionsData = async () => {

        const response = await fetch(
                `${url}rest/trees/region_websurvey2015/${locale}/${numericCountryCode}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            return await response.json()
    }
    that.getLevelOneRegions = async () => {
        const data = await that._getRegionsData();

        let regions = map( data.children, regionItem)
        regions = sortBy(regions, ['name']);
        return regions
    }
    that.getLevelTwoRegions = async (levelOneRegionId) => {
        const data = await that._getRegionsData();

        const levelOneRegion = find(data.children, {id: levelOneRegionId});

        let regions = map( levelOneRegion.children, regionItem)
        regions = sortBy(regions, ['name']);
        return regions
    }

    return that
};

